import React from 'react';

const MiniAppPreview = ({ theme }) => {
  // Sample data for the mini preview
  const sampleTable = {
    id: 1,
    name: 'Table 1',
    status: 'occupied',
    orderCount: 3,
    total: 125.50
  };

  const sampleProducts = [
    { id: 1, name: 'Burger', price: 12.99 },
    { id: 2, name: 'Fries', price: 5.99 },
    { id: 3, name: 'Soda', price: 2.99 }
  ];

  return (
    <div style={{
      background: theme.colors.background,
      padding: '0.75rem',
      borderRadius: theme.borderRadius,
      border: `1px solid ${theme.colors.border}`,
      fontFamily: theme.fonts.main,
      minHeight: '200px',
      maxHeight: '300px',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0.5rem 0',
        borderBottom: `1px solid ${theme.colors.border}`,
        marginBottom: '0.75rem'
      }}>
        <h3 style={{
          margin: 0,
          color: theme.colors.primary,
          fontSize: '1rem'
        }}>
          POS Preview
        </h3>
        <div style={{
          padding: '0.25rem 0.5rem',
          backgroundColor: theme.colors.primary,
          color: theme.colors.textLight,
          borderRadius: theme.borderRadius,
          fontSize: '0.75rem'
        }}>
          {sampleTable.name}
        </div>
      </div>

      {/* Table Info Card */}
      <div style={{
        background: theme.colors.surface,
        padding: '0.5rem',
        borderRadius: theme.borderRadius,
        marginBottom: '0.75rem',
        border: `1px solid ${theme.colors.border}`
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
          <span style={{ color: theme.colors.textSecondary, fontSize: '0.8rem' }}>Status:</span>
          <span style={{ 
            color: sampleTable.status === 'occupied' ? theme.colors.success : theme.colors.warning,
            fontWeight: 'bold',
            fontSize: '0.8rem'
          }}>
            {sampleTable.status === 'occupied' ? 'Occupied' : 'Available'}
          </span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
          <span style={{ color: theme.colors.textSecondary, fontSize: '0.8rem' }}>Items:</span>
          <span style={{ color: theme.colors.text, fontSize: '0.8rem' }}>{sampleTable.orderCount}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span style={{ color: theme.colors.textSecondary, fontSize: '0.8rem' }}>Total:</span>
          <span style={{ color: theme.colors.text, fontWeight: 'bold', fontSize: '0.8rem' }}>${sampleTable.total.toFixed(2)}</span>
        </div>
      </div>

      {/* Product List */}
      <div style={{ flex: 1, overflowY: 'auto', marginBottom: '0.75rem' }}>
        <h4 style={{ 
          margin: '0 0 0.5rem 0', 
          color: theme.colors.text,
          fontSize: '0.85rem'
        }}>
          Products
        </h4>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
          {sampleProducts.map((product, index) => (
            <div 
              key={index}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '0.25rem 0.5rem',
                background: index % 2 === 0 ? 'transparent' : theme.colors.background,
                borderRadius: theme.borderRadius,
                border: `1px solid ${theme.colors.border}20`
              }}
            >
              <span style={{ color: theme.colors.text, fontSize: '0.8rem' }}>{product.name}</span>
              <span style={{ color: theme.colors.text, fontSize: '0.8rem' }}>${product.price.toFixed(2)}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Action Buttons */}
      <div style={{ display: 'flex', gap: '0.5rem' }}>
        <button style={{
          flex: 1,
          padding: '0.4rem 0.6rem',
          backgroundColor: theme.colors.primary,
          color: theme.colors.textLight,
          border: 'none',
          borderRadius: theme.borderRadius,
          cursor: 'pointer',
          fontSize: '0.8rem'
        }}>
          Add Item
        </button>
        <button style={{
          flex: 1,
          padding: '0.4rem 0.6rem',
          backgroundColor: theme.colors.secondary,
          color: theme.colors.textLight,
          border: 'none',
          borderRadius: theme.borderRadius,
          cursor: 'pointer',
          fontSize: '0.8rem'
        }}>
          Close Order
        </button>
      </div>
    </div>
  );
};

export default MiniAppPreview;